import { strTruncate } from "@/utils/strings";

export default {
  name: "Breadcrumbs",
  data() {
    return { truncateLength: 30, truncatePadding: 3 };
  },
  computed: {
    /**
     * Generate the breadcumbs to display.
     */
    breadcrumbs() {
      const breadcrumbs = [];
      if (this.$store.state.breadcrumbs.length) {
        this.$store.state.breadcrumbs.forEach((breadcrumb, index) => {
          breadcrumbs.push({
            isLast: this.isLast(index),
            title: this.breadcrumbTitle(breadcrumb),
            text: this.breadcrumbTruncate(breadcrumb),
            to: breadcrumb.target || breadcrumb.url,
            absolute: breadcrumb.url_absolute || false,
          });
        });
      }
      return breadcrumbs;
    },
  },
  methods: {
    /**
     * Check whether the breadcrumb with the specified index is the last one in the breadcrumbs list.
     * @param {Number} index
     * @returns
     */
    isLast(index) {
      return index == this.$store.state.breadcrumbs.length - 1;
    },

    /**
     * If the breadcrumb has translated text which is longer than this.truncateLength + this.truncatePadding then
     * truncate it. We do not truncate if we are using a translation string because we assume that the translation
     * is already sized sensibly.
     *
     * @param {Object} breadcrumb
     *
     * @returns {String}
     */
    breadcrumbTruncate(breadcrumb) {
      // Do not truncate if we are using a translation key - we assume that the translation is an ok length
      if (!breadcrumb.textTranslated) {
        return this.$t(breadcrumb.text);
      }

      // If we are not using a translation key then we truncate the text if it is too long
      const text = breadcrumb.text.trim();
      if (text.length > this.truncatePadding) {
        return strTruncate(text, this.truncateLength);
      }
      return text;
    },

    /**
     * Get a title string for the breadcrumb.
     * Only returns title if the string would be truncated by breadcrumbTruncate().
     * The idea is that we only need to show a title if the breadcrumb's text has been truncated.
     *
     * @param {Object} breadcrumb
     *
     * @returns {String}
     */
    breadcrumbTitle(breadcrumb) {
      // If we are using a translation key then the text will not be truncated so does not need a title.
      if (!breadcrumb.textTranslated) {
        return "";
      }

      return breadcrumb.text.length > this.truncatePadding ? breadcrumb.text : "";
    },
  },
};
